module.exports = __webpack_public_path__ + "static/media/facebookicon.765d0f7d.svg";